module.exports = __webpack_public_path__ + "img/SVG3.61ea2c91.svg";